import(/* webpackMode: "eager" */ "/home/runner/work/Okkanti/Okkanti/src/app/(public)/provider/[providerProfileId]/error.tsx");
